import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { LightboxModal } from "../components/LightboxModal";
import { WebForm } from "../components/WebForm";
import { BeforeAfterSlider } from "../components/BeforeAfterSlider";
import { COMPANY_INFO, SERVICES_LIST } from "../data/company";
import { fetchCmsCollection } from "../lib/cms";

export function ServiceDetailPage() {
  const { serviceSlug } = useParams();
  const currentSlugKey = `vi-tilbyder-${serviceSlug}`;

  // Find static fallback definition
  const serviceDef = SERVICES_LIST.find(
    (s) => s.slug === currentSlugKey || s.slug.endsWith(serviceSlug)
  ) || SERVICES_LIST[0];

  const [cmsService, setCmsService] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    async function loadData() {
      // Fetch service details from CMS 'ydelser'
      const ydelserList = await fetchCmsCollection("ydelser");
      const matchedService = ydelserList.find(
        (y) =>
          y.slug === currentSlugKey ||
          y.slug === serviceSlug ||
          y.gallery_slug === serviceDef.gallerySlug
      );
      if (matchedService) {
        setCmsService(matchedService);
      }

      // Fetch connected galleries from CMS 'galleri'
      const galleryList = await fetchCmsCollection("galleri");
      const matchedGalleries = galleryList.filter(
        (g) =>
          g.service_slug === serviceDef.gallerySlug ||
          g.service_slug === serviceSlug ||
          g.slug === serviceDef.gallerySlug ||
          g.slug === serviceSlug
      );

      let allImgs = [];
      matchedGalleries.forEach((gal) => {
        if (Array.isArray(gal.images) && gal.images.length > 0) {
          allImgs = [...allImgs, ...gal.images];
        }
      });

      // If no CMS images found for this category, use fallback scrape images for that category
      if (allImgs.length === 0) {
        if (serviceDef.gallerySlug === "flise-og-klinkearbejde") {
          allImgs = [
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/61cc6dfd2b6c9.jpeg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/15591380-1857163961234333-7518727920792048166-o.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/15591635-1857163994567663-59624108023751959-o.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/15625974-1857163957901000-861786210663063810-o.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/15626486-1857163991234330-1734202834763703673-o.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/5f88277e615e7.jpeg"
          ];
        } else if (serviceDef.gallerySlug === "badevaerelser") {
          allImgs = [
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/60a94937977c3.jpeg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/60a9493795d11.jpeg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/60a9493793eda.jpeg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/img-6586.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/img-6693.jpg"
          ];
        } else if (serviceDef.gallerySlug === "reparationer") {
          allImgs = [
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/img-8210.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/img-8211.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/a-sterbrogade-fa-r.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/a-sterborgade-efter.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/007.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/nokia-ma.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/001.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/006.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/nokia-maj2011-070.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/005.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/gesims-efter-28medium-29.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/trappe-efter.jpg"
          ];
        } else if (serviceDef.gallerySlug === "renovering") {
          allImgs = [
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/61cc68288b610.jpeg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/61cc6828a6d8f.jpeg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/61cc6828a8a8a.jpeg"
          ];
        } else if (serviceDef.gallerySlug === "tilbygning") {
          allImgs = [
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/sct-j-c3-b8rgens-bakke-a.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/sct-j-c3-b8rgens-bakke-b.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/sct-j-c3-b8rgens-bakke-c.jpg"
          ];
        } else if (serviceDef.gallerySlug === "nybyggeri") {
          allImgs = [
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/dolken.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/dolken-12.jpg",
            "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/13416988-1758555884428475-5316945199868954005-o.jpg"
          ];
        }
      }

      setGalleryImages(allImgs);
    }

    loadData();
  }, [serviceSlug, currentSlugKey, serviceDef.gallerySlug]);

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const title = cmsService?.title || serviceDef.title;
  const metaTitle = cmsService?.meta_title || `${title} - Kokholm Byg`;
  const metaDescription = cmsService?.meta_description || cmsService?.short_description || serviceDef.shortDescription;
  const contentHtml = cmsService?.content || `<p>${serviceDef.shortDescription}</p>`;

  const relatedServices = SERVICES_LIST.filter(
    (s) => s.slug !== serviceDef.slug && s.slug !== currentSlugKey
  );

  return (
    <div className="min-h-screen flex flex-col pt-28 pb-16 bg-[#f3f4f6]">
      <SEO title={metaTitle} description={metaDescription} />

      {/* Hero Header */}
      <section 
        style={{ marginTop: '-40px' }}
        className="bg-[#1e2329] text-white py-14 border-b border-[#2d343f]"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 text-xs text-[#c06228] font-bold uppercase tracking-wider mb-2">
              <Link to="/ydelser" className="hover:underline">Ydelser</Link>
              <i className="fa-solid fa-chevron-right text-[10px]" aria-hidden="true" />
              <span>{title}</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
              {title}
            </h1>
            <p className="text-gray-300 text-sm sm:text-base mt-2">
              Udført med faglig præcision af Kokholm Byg i Holstebro og omegn.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content & Gallery Area */}
      <section className="py-12 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            
            {/* Left Content Column */}
            <div className="lg:col-span-8 space-y-10">
              
              {/* Rich Text Prose from CMS / Scrape */}
              <div className="bg-white p-6 sm:p-10 rounded border border-gray-200 shadow-sm space-y-6">
                <div 
                  className="prose prose-slate max-w-none text-gray-700 leading-relaxed text-sm sm:text-base space-y-4 [&>h2]:text-2xl [&>h2]:font-bold [&>h2]:text-[#1e2329] [&>h2]:mt-6 [&>h3]:text-xl [&>h3]:font-bold [&>h3]:text-[#1e2329] [&>ul]:list-disc [&>ul]:pl-5 [&>ul]:space-y-1"
                  dangerouslySetInnerHTML={{ __html: contentHtml }}
                />

                <div className="pt-6 border-t border-gray-100 flex flex-wrap items-center justify-between gap-4">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="fa-solid fa-phone text-[#c06228]" aria-hidden="true" />
                    <span>Ring for tilbud: </span>
                    <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="nowrap-contact font-bold text-[#1e2329] hover:text-[#c06228]">
                      <span className="whitespace-nowrap">{COMPANY_INFO.phone}</span>
                    </a>
                  </div>

                  <Link
                    to="/kontakt"
                    className="btn-cta text-sm font-semibold px-5 py-2.5 rounded shadow"
                  >
                    Bestil uforpligtende tilbud
                  </Link>
                </div>
              </div>

              {/* Før & Efter sektion ved reparationer */}
              {(serviceDef.gallerySlug === "reparationer" || serviceSlug?.includes("reparation")) && (
                <div className="space-y-6">
                  <div className="border-b border-gray-200 pb-3">
                    <span className="text-[#c06228] text-xs font-bold uppercase tracking-wider">
                      Dokumenterede resultater
                    </span>
                    <h2 className="text-2xl font-bold text-[#1e2329]">
                      Før & Efter Reparationsarbejde
                    </h2>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Eksempel 1: Murværk & facadereparation */}
                    <BeforeAfterSlider
                      beforeImage="https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/img-8210.jpg"
                      afterImage="https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/img-8211.jpg"
                      beforeLabel="Før"
                      afterLabel="Efter"
                      title="Murværk & facadereparation"
                      onOpenLightbox={(idx = 0) => openLightbox(idx)}
                    />

                    {/* Eksempel 2: Reparation på Østerbrogade */}
                    <BeforeAfterSlider
                      beforeImage="https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/a-sterbrogade-fa-r.jpg"
                      afterImage="https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/a-sterborgade-efter.jpg"
                      beforeLabel="Før"
                      afterLabel="Efter"
                      title="Reparation på Østerbrogade"
                      onOpenLightbox={(idx = 0) => openLightbox(idx + 2)}
                    />
                  </div>
                </div>
              )}

              {/* Connected CMS Photo Gallery */}
              {galleryImages.length > 0 && (
                <div className="bg-white p-6 sm:p-8 rounded border border-gray-200 shadow-sm space-y-6">
                  <div className="flex items-center justify-between pb-3 border-b border-gray-100">
                    <h3 className="text-xl font-bold text-[#1e2329] flex items-center gap-2">
                      <i className="fa-solid fa-camera text-[#c06228]" aria-hidden="true" />
                      <span>Galleri: {title}</span>
                    </h3>
                    <span className="text-xs text-gray-500 font-mono">
                      {galleryImages.length > 9 ? `Viser 9 af ${galleryImages.length} billeder` : `${galleryImages.length} billeder`}
                    </span>
                  </div>

                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                    {galleryImages.slice(0, 9).map((src, idx) => (
                      <div
                        key={`${src}-${idx}`}
                        onClick={() => openLightbox(idx)}
                        className="group cursor-pointer aspect-4/3 rounded overflow-hidden border border-gray-200 bg-gray-100 relative shadow-sm hover:shadow-md transition-all"
                      >
                        <img
                          src={src}
                          alt={`${title} projekt ${idx + 1}`}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                          loading="lazy"
                        />
                        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                          <i className="fa-solid fa-magnifying-glass-plus text-white text-lg" aria-hidden="true" />
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="pt-2 border-t border-gray-100 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <p className="text-sm text-gray-600">
                      Vil du se flere billeder fra vores arbejde med {title.toLowerCase()}?
                    </p>
                    <Link
                      to={`/galleri?kategori=${serviceDef.gallerySlug || serviceSlug}`}
                      className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-[#1e2329] hover:bg-[#c06228] text-white text-sm font-semibold rounded shadow-xs transition-colors whitespace-nowrap"
                    >
                      <span>Se flere billeder i galleriet</span>
                      <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                    </Link>
                  </div>
                </div>
              )}

              {/* Contact CTA Banner */}
              <div className="bg-[#1e2329] text-white p-8 rounded-lg border border-[#2d343f] flex flex-col sm:flex-row items-center justify-between gap-6 shadow-md">
                <div className="space-y-1">
                  <h3 className="text-xl font-bold text-white">Ønsker du et tilbud på {title.toLowerCase()}?</h3>
                  <p className="text-gray-300 text-sm">
                    Ring eller skriv til os for en uforpligtende drøftelse af dit projekt.
                  </p>
                </div>
                <Link
                  to="/kontakt"
                  className="btn-cta text-sm font-semibold px-6 py-3 rounded shadow whitespace-nowrap"
                >
                  Gå til kontaktformular
                </Link>
              </div>

            </div>

            {/* Sidebar Column */}
            <div className="lg:col-span-4 space-y-8">
              
              {/* Quick Contact Box */}
              <div className="bg-[#1e2329] text-white p-6 rounded border border-[#2d343f] space-y-4 shadow-md">
                <h3 className="text-xl font-bold text-white border-b border-[#373f4b] pb-3">
                  Spørgsmål til {title}?
                </h3>
                <p className="text-sm text-gray-300 leading-relaxed">
                  Ring direkte til Kokholm Byg for rådgivning eller et skriftligt tilbud.
                </p>
                <div className="space-y-3 pt-2">
                  <a
                    href={`tel:${COMPANY_INFO.phoneRaw}`}
                    className="nowrap-contact flex items-center justify-center gap-2 py-3 px-4 bg-[#272d36] hover:bg-[#323945] text-white font-semibold rounded text-sm transition-colors border border-[#373f4b]"
                  >
                    <i className="fa-solid fa-phone text-[#c06228]" aria-hidden="true" />
                    <span className="whitespace-nowrap">{COMPANY_INFO.phone}</span>
                  </a>
                  <a
                    href={`mailto:${COMPANY_INFO.email}`}
                    className="nowrap-contact flex items-center justify-center gap-2 py-3 px-4 bg-[#272d36] hover:bg-[#323945] text-white font-semibold rounded text-sm transition-colors border border-[#373f4b]"
                  >
                    <i className="fa-solid fa-envelope text-[#c06228]" aria-hidden="true" />
                    <span className="whitespace-nowrap">{COMPANY_INFO.email}</span>
                  </a>
                </div>
              </div>

              {/* Related Services */}
              <div className="bg-white p-6 rounded border border-gray-200 shadow-sm space-y-4">
                <h3 className="text-lg font-bold text-[#1e2329] border-b border-gray-100 pb-3">
                  Relaterede ydelser
                </h3>
                <div className="space-y-3">
                  {relatedServices.map((rel) => (
                    <Link
                      key={rel.slug}
                      to={`/vi-tilbyder/${rel.slug.replace('vi-tilbyder-', '')}`}
                      className="group flex items-start gap-3 p-3 rounded hover:bg-[#f3f4f6] transition-colors border border-transparent hover:border-gray-200"
                    >
                      <div className="w-8 h-8 rounded bg-[#1e2329] text-[#c06228] flex items-center justify-center text-sm shrink-0 group-hover:bg-[#c06228] group-hover:text-white transition-colors">
                        <i className={rel.icon} aria-hidden="true" />
                      </div>
                      <div>
                        <h4 className="font-bold text-sm text-[#1e2329] group-hover:text-[#c06228] transition-colors">
                          {rel.title}
                        </h4>
                        <p className="text-xs text-gray-500 line-clamp-1 mt-0.5">
                          {rel.shortDescription}
                        </p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      <LightboxModal
        isOpen={lightboxOpen}
        images={galleryImages}
        currentIndex={currentImageIndex}
        onClose={() => setLightboxOpen(false)}
        onPrev={() => setCurrentImageIndex((prev) => (prev > 0 ? prev - 1 : galleryImages.length - 1))}
        onNext={() => setCurrentImageIndex((prev) => (prev < galleryImages.length - 1 ? prev + 1 : 0))}
      />
    </div>
  );
}
